import React from 'react';
import {RegularPolygon} from 'react-konva';

interface CaretInterface {
  x: number;
  y: number;
  rotation?: number;
}

const Caret: React.FC<CaretInterface> = ({x, y, rotation = 0}) => {
  return (
    <RegularPolygon
      x={x}
      y={y}
      sides={3}
      radius={5}
      rotation={rotation}
      fill="black"
      stroke="black"
    />
  );
};

export default Caret;
